/* 
 * 报警计划详情 
 * 描述：
 * 创建时间：2017-03-22 
 * 创建人：zhanlz
 */
<template>
	<div class="wrapper wrapper-content animated fadeInRight tabBox" id="alarmplan-detail">
        <div class="ibox-content" v-loading="loadingstatus.detail" element-loading-text="加载中">
        	<div class="row">
        		<div class="col-sm-12">
        			 <div class="add_alarm_list_box">
					    <div class="page_title ">
	        			<p><a @click="init">{{alarmTypeTitle}}报警</a><span>&gt;</span><a v-if="alarmPlanTitle !== ''">{{alarmPlanTitle}}</a></p>
						<span class="page_title_btn"><a  v-show="!isFirstPage" @click="getPrePlan">上一页</a><a v-show="!isLastPage" @click="getNextPlan">下一页</a></span>
	        			</div>
	        			<div class="add_alarm_list">
	        				<dl>
	        					<dt v-if="permission.indexOf('alarmPlanHome_areaAlarmHomeInsert') == -1" @click="gotoAlarmDetail"><a><i  class="icon iconfont icon-jia"></i><span>新建报警计划</span></a></dt>
	        					<dd v-for="item in alarmInfoList"> 
	        						<a @click="resetChartPlan(item.id,item.planName)"><span v-if="item.almLevel === 1" class="alarm_list_bg06">{{item.planName}}</span></a>
	        						<a @click="resetChartPlan(item.id,item.planName)"><span v-if="item.almLevel === 2" class="alarm_list_bg05">{{item.planName}}</span></a>
	        						<a @click="resetChartPlan(item.id,item.planName)"><span v-if="item.almLevel === 3" class="alarm_list_bg09">{{item.planName}}</span></a>
					                <a @click="resetChartPlan(item.id,item.planName)">
					                	<p>
						                	<b v-if="item.almLevel === 1">ID:AP{{item.id}} | 紧急度:紧急</b>
						                	<b v-if="item.almLevel === 2">ID:AP{{item.id}} | 紧急度:普通</b>
						                	<b v-if="item.almLevel === 3">ID:AP{{item.id}} | 紧急度:提醒</b>
						                	<b v-if="item.isEnable === 0">状态:停用</b>
						                	<b v-if="item.isEnable === 1">状态:启用</b>
						                	<b>监控车辆数:{{item.vehicleCount}}辆</b>
						                	<b>创建人:{{item.createName}}</b>
					               		 </p>
					                </a>
					                <i>
					                	<a @click="gotoEditAlarmDetail(item.id,item.planName,'2')">查看</a>
					                	&nbsp&nbsp&nbsp&nbsp
					                	<a v-if="permission.indexOf('alarmPlanHome_areaAlarmHomeUpdate') == -1" @click="gotoEditAlarmDetail(item.id,item.planName,'1')">编辑</a>
					                </i> 
					                <em class="focus_color">发生了{{item.almCount}}次报警</em> 
	        					</dd>
                  
	        				</dl>
	        			</div>
        			</div>
        		</div>
        	</div>
        </div>
        <!--图形区域-->
    	<div class="row pt10px">
			<div class="col-sm-3" >
				<div>
					<div class="ibox float-e-margins" v-loading="loadingstatus.pie" element-loading-text="加载中">
						<div class="  bgfff">
							<div class="module_title04">
								<span>已监控车辆分析(统计截至到昨日)：</span>
							</div>
							<div class="ibox-content alarm_info_list" style="height:180px;">
								<pie-chart 
									v-if="pieSeries.showPie"
									:itemOn="pieSeries.itemOn" 
									:itemOff="pieSeries.itemOff"
									:cntOn="pieSeries.cntOn"
									:cntOff="pieSeries.cntOff"
									lcolor="#57B83A"
									rcolor="#DE3738"
									>
								</pie-chart>
							</div>
							<div class="monitor_text_tip">
								<span class="green">已监控：{{pieSeries.cntOn}}</span><span class="red">未监控：{{pieSeries.cntOff}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-9" >
				<div>
					<div class="ibox float-e-margins" v-loading="loadingstatus.bar" element-loading-text="加载中">
						<div class="  bgfff">
							<div class="module_title04">
								<span>报警数量分析(统计截至到昨日)：</span>
							</div>
							<div class="ibox-content alarm_info_list" style="height:180px;">
								<bar-two-chart 
									v-if="barSeries.showBar"
									:oneTitle="barSeries.oneTitle" 
									:twoTitle="barSeries.twoTitle"
									:titleList="barSeries.titleList"
									:oneBarData="barSeries.oneBarData"
									:twoBarData="barSeries.twoBarData"
									>
								</bar-two-chart>
							</div>
							<div class="monitor_text_tip">
								<span class="red">发生的报警数量：{{barSeries.oneBarDataTotal}}</span><span class="green">处理完的报警数量：{{barSeries.twoBarDataTotal}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <!--时间轴区域-->
    	<div class="row" v-if="alarmPlanTitle !== ''">
    		<div class="col-sm-12">
    			<div class="ibox float-e-margins" v-loading="loadingstatus.timeline" element-loading-text="加载中">
    				<div class="bgfff">
    					<div class="module_title04">
							<span>报警历史分析：</span>
							<span class="page_title_btn"><a v-show="!isTimelineFirstPage" @click="getTimePrePlan">上一页</a><a v-show="!isTimelineLastPage" @click="getTimeNextPlan">下一页</a></span>
						</div>
						<div class="ibox-content alarm_info_list">
							<div class="row">
								<div class="col-sm-12">
								    <div  class="message_timeline" >
									   <ul>
										   <li :class="{active: timelineSelect == item.eventId,color02:item.eventType!='1'}" v-for="item in alarmTimeInfoList" @click="timelineSelected(item.eventId,item.eventDetails,item.almMsgId,item.vehicleId,item.eventType)">
										   		<p>
										   			<a></a>
										   			<span>{{item.eventDesc}}</span>
										   		</p>
										   </li>
									   </ul>
									</div>
									<div class="message_timeline_text"><span>{{timelineDesc}}</span>
										<button v-if="timelineSelect!=''&& eventType!=1" type="button" class="btn-primary btn" @click="gotoTrace">报警现场回放</button>
									</div>
								</div>
							</div>
						</div>
    				</div>
    			</div>
    		</div>
		</div>
        
        <!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
	import { OPERATE_EXCEPTION } from 'static/message'
	import PieChart from 'components/modules/bulletin/PieChart'
	import BarTwoChart from 'components/modules/bulletin/BarTwoChart'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	
	export default{
		name: 'PageAlarmPlanDetail',
		components: {
			TabModal,
			PieChart,
			BarTwoChart
		},
		data(){
			return{
				permission:this.$store.state.permission.permission["alarmPlanHome"]?this.$store.state.permission.permission["alarmPlanHome"]:[],
				loadingstatus:{
					detail:false,
					pie:false,
					bar:false,
					timeline:false
				},
				// 报警计划信息查询条件
				queryParam:{
					planOwnerType:1,
					customerId:this.$store.state.user.groupid,
					almType:'',
					page_index:1
				},
				// 报警计划事件信息查询条件
				timeQueryParam:{
					planId:'',
					page_index:1
				},
				// 饼图信息源
				pieSeries:{
					itemOn:'已监控',
					itemOff:'未监控',
					cntOn:'0',
					cntOff:'0',
					showPie:false
				},
				// 柱状图信息源
				barSeries:{
					oneTitle:'已发生',
					twoTitle:'已处理',
					titleList:[],
					oneBarData:[],
					oneBarDataTotal:0,
					twoBarData:[],
					twoBarDataTotal:0,
					showBar:false
				},
				timelineSelect:'',
				timelineDesc:'',
				msgid:'',
				vehicleid:'',
				pageName:'',											// 画面ID
				alarmTypeTitle:'',									    // 一级名称
				alarmPlanTitle:'',										// 二级名称
				alarmInfoList:[],										// 报警计划信息列表
				alarmTimeInfoList:[],								    // 报警计划事件列表
				isFirstPage:true,										// 是否第一页
				isLastPage:false,										// 是否第二页
				isTimelineFirstPage:true,							    // 时间轴是否第一页
				isTimelineLastPage:false,							    // 时间轴是否第二页
				scrollTop:'0',
				messageStr:'',
				eventType:''
			}
		},
		// 接收报警计划类型参数
		created(){
			this.queryParam.almType = this.$route.query.almtype;
			this.alarmTypeTitle = this.$route.query.almname;
			this.pageName = this.$route.query.pagename;
		},
		// 组件初始化
		beforeMount(){
			this.getPlanDetail();
			this.getPieInfoByType();
			this.getBarInfoByType();
		},
		methods:{
			// 恢复初始化
			init(){
				this.getPlanDetail();
				this.getPieInfoByType();
				this.getBarInfoByType();
				this.alarmPlanTitle = '';
				this.alarmTimeInfoList=[];
				this.timelineSelect='';
				this.timelineDesc='';
				this.timeQueryParam.page_index=1;
				this.isTimelineFirstPage=true;							    // 时间轴是否第一页
				this.isTimelineLastPage=false;							    // 时间轴是否第二页
			},
			// 计划详细查询
			getPlanDetail(){
				this.loadingstatus.detail = true;
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans', {params:this.queryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.alarmInfoList = resInfo.list;
						this.isFirstPage = resInfo.isFirstPage;
						this.isLastPage = resInfo.isLastPage;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.detail = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.detail = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.detail = false;
				})
			},
			// 饼图信息查询(根据类型)
			getPieInfoByType(){
				this.loadingstatus.pie = true;
				const pieQueryParam = {
					almType:this.queryParam.almType,
					cuntomerId:this.$store.state.user.groupid
				}
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/vehicles/alm-type', {params:pieQueryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.pieSeries.cntOn = resInfo.vehMonitoredCount;
						this.pieSeries.cntOff = resInfo.vehUnmonitoredCount;
						this.pieSeries.showPie = true;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.pie = false;
				}, res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.pie = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.pie = false;
				})
			},
			// 饼图信息查询(根据计划)
			getPieInfoByPlan(planId){
				this.loadingstatus.pie = true;
				const pieQueryParam = {
					planId:planId,
					cuntomerId:this.$store.state.user.groupid
				}
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/vehicles/alm-plan', {params:pieQueryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.pieSeries.cntOn = resInfo.vehMonitoredCount;
						this.pieSeries.cntOff = resInfo.vehUnmonitoredCount;
						this.pieSeries.showPie = true;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.pie = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.pie = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.pie = false;
				})
			},
			// 柱图信息查询(根据类型)
			getBarInfoByType(){
				this.loadingstatus.bar = true;
				const pieQueryParam = {
					almType:this.queryParam.almType,
					cuntomerId:this.$store.state.user.groupid
				}
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/messages/alm-type', {params:pieQueryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.conBarData(resInfo);
						this.barSeries.showBar = true;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.bar = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.bar = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.bar = false;
				})
			},
			// 柱图信息查询(根据计划)
			getBarInfoByPlan(planId){
				this.loadingstatus.bar = true;
				const pieQueryParam = {
					planId:planId,
					cuntomerId:this.$store.state.user.groupid
				}
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/messages/alm-plan', {params:pieQueryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.conBarData(resInfo);
						this.barSeries.showBar = true;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.bar = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.bar = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.bar = false;
				})
			},
			// 时间轴信息查询(根据计划)
			getTimelineInfoByPlan(planId){
				this.loadingstatus.timeline = true;
				if (typeof(planId) !== "undefined") { 
				   this.timeQueryParam.planId = planId;
				} 
				this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/events', {params:this.timeQueryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;
						this.alarmTimeInfoList = resInfo.list;
						this.isTimelineFirstPage = resInfo.isFirstPage;
						this.isTimelineLastPage = resInfo.isLastPage;
					} else {
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus.timeline = false;
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus.timeline = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus.timeline = false;
				})
			},
			timelineSelected(eventid,desc,msgid,vehicleid,eventType) {
		      this.timelineSelect = eventid;
		      this.timelineDesc = desc;
		      this.msgid=msgid;
		      this.vehicleid=vehicleid;
		      this.eventType=eventType;
		    },
			// 根据计划重绘图形信息
			resetChartPlan(planId,planName){
				this.getPieInfoByPlan(planId);
				this.getBarInfoByPlan(planId);
				this.getTimelineInfoByPlan(planId);
				this.alarmPlanTitle = planName;
				this.alarmTimeInfoList=[];
				this.timelineSelect='';
				this.timelineDesc='';
			},
			// 组织柱图数据
			conBarData(val){
				let ltitleList = [];
				let loneBarData = [];
				let ltwoBarData = [];
				let that = this;
				this.barSeries.oneBarDataTotal=0;
				this.barSeries.twoBarDataTotal=0
				val.forEach(function(e){  
				    ltitleList.push(e.yearMonth);
				    that.barSeries.oneBarDataTotal+=e.almMsgCount;
				    that.barSeries.twoBarDataTotal+=e.almMsgSolvedCount;
				    loneBarData.push(e.almMsgCount);
				    ltwoBarData.push(e.almMsgSolvedCount);
				})
				this.barSeries.titleList=[];
				this.barSeries.oneBarData=[];
				this.barSeries.twoBarData=[];
				this.barSeries.titleList=ltitleList;
				this.barSeries.oneBarData=loneBarData;
				this.barSeries.twoBarData=ltwoBarData; 
			},
			//新建报警计划
			gotoAlarmDetail(){
				const obj = {
					name:this.alarmTypeTitle + '报警计划',
					id:'Page' + this.pageName.charAt(0).toUpperCase() + this.pageName.slice(1),
					route:'/indexhome/' + this.pageName,
					No:this.pageName,
					params:{mode: "0",planid:''}
				}
				this.$router.push({path:'/indexhome/' +  this.pageName,query:{mode: "0",planid:''}});
				this.$store.dispatch('addTab',obj);
			},
			//编辑报警计划
			gotoEditAlarmDetail(planid,name,mode){
					let param = {
	    				planId:planid,
	    				type:"1",
	    			}
					let modename='edit';
					if(mode==='2'){
						param = {
	    					planId:planid,
	    				};
	    				modename="view"
					}
					const selfUrl=process.env.API_ROOT
					this.loadingstatus.detail = true;
					this.$http.get(selfUrl+'/alarm/alarm-plans/'+planid+'/info',{params: param})
					.then( res => {
						if(res.body.success){
							const obj = {
								name:this.alarmTypeTitle + '报警计划-' + name,
								id:'Page' + this.pageName.charAt(0).toUpperCase() + this.pageName.slice(1),
								route:'/indexhome/' + this.pageName + planid + modename,
								No:this.pageName + planid + modename,
								params:{mode: "1",planid:planid}
							}
							this.$router.push({path:'/indexhome/' +  this.pageName,query:{mode: mode,planid:planid}});
							this.$store.dispatch('addTab',obj);
						}else{
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus.detail = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus.detail = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.detail = false;
					})
			},
			//报警回放现场
			gotoTrace(){
				if (this.msgid==""||this.vehicleid==""){
					this.openModalMsg("报警未选择");
					return;
				}
				//1，进入轨迹回放tab
				const obj = {
					name:'车辆轨迹回放',
					code:'vehicleTrace',
					id:'PageVehicleTrace',
					route:'/indexhome/vehicleTrace',
					No:'vehicleTrace'
				}
				this.addTab(obj);
				//2,追加报警现场队列
				const param = {
					almMsgId:this.msgid,
					vehicleId:this.vehicleid
				}
				this.$store.dispatch('addAlarmLive',param)
			},
			addTab(obj){//进入tab窗口
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
			},
			// 计划详细下一步
			getNextPlan(){
				this.queryParam.page_index +=1;
				this.getPlanDetail();
			},
			// 计划详细上一步
			getPrePlan(){
				this.queryParam.page_index -=1;
				this.getPlanDetail();
			},
			// 时间轴下一步
			getTimeNextPlan(){
				this.timeQueryParam.page_index +=1;
				this.getTimelineInfoByPlan();
			},
			// 时间轴上一步
			getTimePrePlan(){
				this.timeQueryParam.page_index -=1;
				this.getTimelineInfoByPlan();
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#alarmplan-detail',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#alarmplan-detail',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	}
</script>

<style scoped>
.green {
	color:#57B83A
}

.red {
	color:#DE3738
}
</style>


// WEBPACK FOOTER //
// PageAlarmPlanDetail.vue?21d5e20f